export const isString = (x: any): x is string => typeof x === 'string'

export function capitalize(string: string): string {
    return string.charAt(0).toUpperCase() + string.slice(1)
}
